<script setup lang="ts">
import type { ComputeProviderConfig } from '@clovyr/pollen';

import SettingOption from '@/components/blocks/SettingOption.vue';
import SettingsSection from '@/components/blocks/SettingsSection.vue';

import SavedHost from './SavedHost.vue';

defineProps({
  savedHosts: {
    type: Array<ComputeProviderConfig>,
  },
});
</script>

<template>
  <SettingsSection heading-text="Saved Hosting Providers" :default-closed="true">
    <template #content>
      <div v-if="savedHosts">
        <SavedHost v-for="host of savedHosts" :key="host.id" :id="host.id" />
      </div>
      <SettingOption v-if="savedHosts?.length === 0" highlighted>
        <template #left>You currently have no saved hosts.</template>
      </SettingOption>
    </template>
  </SettingsSection>
</template>
<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
:deep(.setting-option--highlighted:first-child) {
  margin-top: unset;
}
</style>
